module.exports = __webpack_public_path__ + "static/media/bookings.f90aa466.svg";